// hero-toggle-icons.js

document.addEventListener('DOMContentLoaded', () => {
  // 1) Initialize every hero-toggle-icons section on the page
  document
    .querySelectorAll('[id^="hero-toggle-icons-"]')
    .forEach(root => {
      const radios     = root.querySelectorAll('.paint-radio');
      const indicator  = root.querySelector('.toggle-indicator');
      const labels     = root.querySelectorAll('.toggle-option');
      const lists      = {
        peelable : root.querySelector('.icon-list[data-type="peelable"]'),
        permanent: root.querySelector('.icon-list[data-type="permanent"]')
      };
      const animChoice = root.getAttribute('data-icon-anim');
      const grid       = root.querySelector('.icon-grid');

      // Ensure icon‐grid never collapses when swapping
      function lockGridHeight() {
        const h = Math.max(
          lists.peelable.scrollHeight,
          lists.permanent.scrollHeight
        );
        grid.style.minHeight = h + 'px';
      }
      window.addEventListener('load',  lockGridHeight);
      window.addEventListener('resize', lockGridHeight);
      lockGridHeight();

      // Play entrance animation
      function play(list) {
        list.dataset.anim = animChoice;
        list.classList.add('pre-enter');
        list.querySelectorAll('.icon-item')
            .forEach((el,i) => el.style.setProperty('--stagger', i));
        // force reflow
        void list.offsetHeight;
        list.classList.add('enter-active');
        setTimeout(() => {
          list.classList.remove('pre-enter','enter-active');
        }, 450);
      }

      // Swap logic: highlight label, move indicator, show correct list
      function update() {
        const val = root.querySelector('.paint-radio:checked').value;

        // active label styling
        labels.forEach(l => {
          l.classList.toggle('active', l.dataset.value === val);
        });

        // slide & recolor indicator
        indicator.style.transform = val === 'permanent'
          ? 'translateX(100%)'
          : 'translateX(0%)';
        indicator.style.background = val === 'permanent'
          ? getComputedStyle(root).getPropertyValue('--toggle-2-bg')
          : getComputedStyle(root).getPropertyValue('--toggle-1-bg');

        // show/hide icon‐lists
        Object.entries(lists).forEach(([key,list]) => {
          const show = key === val;
          list.classList.toggle('hidden', !show);
          if (show) play(list);
        });
      }

      // initial state + listeners
      update();
      radios.forEach(radio => radio.addEventListener('change', update));


      // ──────────────────────────────────────────────────────────────────────────
      // 2) MCC‐trigger logic: find any .mcc-icon-link inside THIS hero section,
      //    and, on click, either scroll to a target section OR forward to the 
      //    hidden MCC "Search Color" button.
      // ──────────────────────────────────────────────────────────────────────────

      // a) Grab all <a class="mcc-icon-link"> within this hero section
      const mccTriggers = root.querySelectorAll('.mcc-icon-link');
      if (mccTriggers.length) {
        // b) Find the real MCC "Search Color" button (it lives inside #mccSearchColorWrapper)
        const wrapper = document.getElementById('mccSearchColorWrapper');
        const mccNativeButton = wrapper?.querySelector('button');
        
        if (!wrapper || !mccNativeButton) {
          console.warn('Cannot find MCC search button. Ensure your MCC Search section is present.');
        }
        
        // c) Attach click‐handlers to each "trigger" icon
        mccTriggers.forEach(el => {
          el.addEventListener('click', evt => {
            evt.preventDefault();
            
            // Get the href attribute (e.g., "#mcc-search" or "#25610319659372__carousal_QWr3QA")
            const href = el.getAttribute('href');
            console.log('[Hero Toggle] Icon clicked with href:', href);
            
            if (href && href.startsWith('#')) {
              const targetId = href.substring(1); // Remove the '#'
              console.log('[Hero Toggle] Looking for element with ID:', targetId);
              
              // Try multiple possible ID formats for Shopify sections
              let targetElement = null;
              const possibleIds = [
                targetId,                                        // Exact match
                'shopify-section-template--' + targetId,        // Template prefix
                'shopify-section-' + targetId,                  // Section prefix
                'template--' + targetId,                        // Just template prefix
                targetId.replace(/__/g, '-'),                   // Replace __ with -
                'shopify-section-' + targetId.replace(/__/g, '-') // Section + cleanup
              ];
              
              // Also try to find by data-section-id attribute
              for (const id of possibleIds) {
                console.log('[Hero Toggle] Trying ID:', id);
                targetElement = document.getElementById(id);
                if (targetElement) {
                  console.log('[Hero Toggle] ✓ Found with ID:', id);
                  break;
                }
              }
              
              // If still not found, try querySelector with data-section-id
              if (!targetElement) {
                console.log('[Hero Toggle] Trying data-section-id selector');
                const sectionIdPart = targetId.split('__')[0]; // Get first part before __
                targetElement = document.querySelector(`[data-section-id="${sectionIdPart}"]`) ||
                                document.querySelector(`[id*="${targetId}"]`);
                if (targetElement) {
                  console.log('[Hero Toggle] ✓ Found via querySelector');
                }
              }
              
              // If we found a matching element, scroll to it smoothly
              if (targetElement) {
                console.log('[Hero Toggle] Scrolling to element...');
                // Calculate offset for fixed headers (adjust if needed)
                const headerOffset = 80;
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                
                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              } else {
                console.warn('[Hero Toggle] ✗ Target element not found with any ID format');
                console.log('[Hero Toggle] Available section IDs on page:', 
                  Array.from(document.querySelectorAll('[id*="shopify-section"]')).map(el => el.id)
                );
                
                // Special case: if href is "#mcc-search" and no element found, trigger MCC button
                if (targetId === 'mcc-search' && mccNativeButton) {
                  console.log('[Hero Toggle] Triggering MCC button instead');
                  mccNativeButton.click();
                }
              }
            } 
            // Fallback: if no href or not a hash, trigger MCC button if available
            else if (mccNativeButton) {
              console.log('[Hero Toggle] No hash href, triggering MCC button');
              mccNativeButton.click();
            }
          });
        });
      }
    });
});
